import(/* webpackMode: "eager" */ "/home/meywd/AlUmmahNow/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ActiveChannelWrapper"] */ "/home/meywd/AlUmmahNow/apps/web/src/components/ActiveChannelWrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthContextProvider"] */ "/home/meywd/AlUmmahNow/apps/web/src/components/AuthProvider/authContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieSizeMonitor"] */ "/home/meywd/AlUmmahNow/apps/web/src/components/CookieSizeMonitor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/meywd/AlUmmahNow/apps/web/src/components/navigation/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationCenter"] */ "/home/meywd/AlUmmahNow/apps/web/src/components/notifications/NotificationCenter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/meywd/AlUmmahNow/apps/web/src/components/themeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationSyncProvider"] */ "/home/meywd/AlUmmahNow/apps/web/src/components/TranslationSyncProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MultiAccountProvider"] */ "/home/meywd/AlUmmahNow/apps/web/src/hooks/useMultiAccount.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebSocketProvider"] */ "/home/meywd/AlUmmahNow/apps/web/src/lib/websocket/WebSocketProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/home/meywd/AlUmmahNow/apps/web/src/providers/QueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/home/meywd/AlUmmahNow/node_modules/nuqs/dist/adapters/next/app.js");
